module.exports = __webpack_public_path__ + "static/media/vc.4ac5124f.svg";